import axios from 'axios'
import {host} from '../configuraciones'

//constantes
const dataInicial = {
    loading: false
}
//types
const ACTUALIZAR_LOADING = 'ACTUALIZAR_LOADING'

//reducers
export default function AppReducer(state = dataInicial, action) {
    switch (action.type) {
        case ACTUALIZAR_LOADING:
            return {...state, loading: action.payload}
        default:
            return {...state}
    }
}

//actions
export const actualizarLoadingApp_true = () => async(dispatch) => {
    try {
        // console.log('set loading true ........................');
        dispatch({
            type: ACTUALIZAR_LOADING,
            payload: true
        })
    } catch (error) {
        console.log(error);
    }
}

export const actualizarLoadingApp_false = () => async(dispatch) => {
    try {
        // console.log('set loading false ..........................');
        dispatch({
            type: ACTUALIZAR_LOADING,
            payload: false
        })
    } catch (error) {
        console.log(error);
    }
}